import { render, staticRenderFns } from "./yesLink.vue?vue&type=template&id=78642ec2"
import script from "./yesLink.vue?vue&type=script&lang=js"
export * from "./yesLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports